import React, { useState, useEffect, Suspense, lazy } from "react";
import { Tab, Row, Col, Nav, Container } from "react-bootstrap";
import TitleCommon from "../components/TitleCommon";
import Layout from "../Layout";
import { StyledTabs } from "../components/StyledCommon";
import ReactTooltip from "react-tooltip";
import { useParams } from "react-router-dom";
import DeliveryDashboard from "../components/pharos/DeliveryDashboard";
 

 
const DasboardPharos = () => {
  const [selectedTab, setSelectedTab] = useState("two");
  const [save, setSave] = useState([]);
  const { idView } = useParams();
 
  useEffect(() => {
    ReactTooltip.rebuild();
  });
 
  const savePage = (value) => {
    localStorage.setItem('savePage', value);
  };
 
  const currentPage = localStorage.getItem("savePage") || "two";
 
  return (
    <React.Fragment>
      <Layout save={save}>
        <TitleCommon
          title={{
            text: "Cadena Valor",
            icon: "bars"
          }}
        />
        <Container fluid>
          <Tab.Container
            id="left-tabs-example"
             defaultActiveKey= {(idView) ? idView : currentPage}
            activeKey={selectedTab}
            transition={false}
            onSelect={(e) => setSelectedTab(e)}
          >
            <Row className="bg-light">
              <Col>
                <StyledTabs as={Nav}>
                <Nav.Item >
                    <Nav.Link eventKey="zero" onClick={() => savePage("zero")} disabled={true}>
                      <i class="fas fa-lightbulb mr-2 text-primary"></i>
                      Prepare
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item >
                    <Nav.Link eventKey="one" onClick={() => savePage("one")} disabled={true}>
                      <i class="fas fa-handshake mr-2 text-primary"></i>
                        Propouse
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item >
                    <Nav.Link eventKey="two" onClick={() => savePage("two")}>
                      <i class="fas fa-file-contract mr-2 text-primary"></i>
                      Delivery
                    </Nav.Link>
                  </Nav.Item>
                </StyledTabs>
              </Col>
            </Row>
            <Row>
              <Col className="pt-3 pb-5 mb-5">
                <Tab.Content>
                <Tab.Pane
                    eventKey="zero"
                    className="animate__animated animate__fadeIn"
                  >
                   
                  </Tab.Pane>
                  <Tab.Pane
                    eventKey="one"
                    className="animate__animated animate__fadeIn"
                  >
                   
                  </Tab.Pane>
                  <Tab.Pane
                    eventKey="two"
                    className="animate__animated animate__fadeIn"
                  >
                    <DeliveryDashboard/>
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </Container>
      </Layout>
    </React.Fragment>
  );
};
 
export default DasboardPharos;